import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { ITabs } from 'common';

@Component({
  selector: 'ss-tabs',
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent {
  readonly tabs = model<ITabs[]>([]);
  readonly toggleMode = input<boolean>(false);
  readonly changed = output<string>();
  readonly tabChanged = output<ITabs>(); // keeping events separate to allow backwards compatibility

  openTab(tab: ITabs) {
    if (!tab.disabled) {
      this.tabs.set(
        this.tabs().map((tabEl) => {
          tabEl.open = tabEl === tab;
          return tabEl;
        })
      );
      this.changed.emit(tab.label);
      this.tabChanged.emit(tab);
    }
  }
}
